module.exports = __webpack_public_path__ + "static/CorprateHp-1-fb1afba1c5132e00e758382ebb26b31d.gif";